import * as React from "react";
import { useCurrentStudyConfigurationContext } from "../../Core/CurrentStudyConfigurationContext";

interface CorrectionBreakdownItemProps {
    fieldName: string;
    from;
    to;
}

const CorrectionUserFriendlyName = (fieldName: string) => {
    const { fieldDisplayText } = useCurrentStudyConfigurationContext();

    switch (fieldName) {
        case "VisitScheduleId":
            return "Visit Name";
        case "ScheduleItemId":
            return "Session Label";
        case "IsSupressed":
            return "Is Supressed";
        case "SubjectId":
        case "SubjectNumber":
            return fieldDisplayText.SubjectId;
        case "MediaSerialNumber":
            return "Card Serial Number";
        case "VisitId":
            return "Visit";
        case "SessionId":
            return "Session";
        case "VisitName":
            return "Visit Name";
        case "Label":
            return "Session Label";
        default:
            return fieldName;
    }
}

export const CorrectionBreakdownItem = ({ fieldName, from, to }: CorrectionBreakdownItemProps) => {
    if (!from && !to) {
        return null;
    }

    return (
        <div id={`BreakdownItem_${fieldName}`} className="row">
            <div className="col-md-4">
                <b>{CorrectionUserFriendlyName(fieldName)}</b>
            </div>
            <div className="col-md-4 text-left">
                <del style={{ overflowWrap: 'anywhere' }}>{from}</del>
            </div>
            <div className="col-md-4 text-left">
                <ins style={{ overflowWrap: 'anywhere'}}>{to}</ins>
            </div>
        </div>
    );
};
